export const defaultLazyHtmlConfig = () => {
    const data = ICube.data;
    
    return {
        exception: '.ci-body-loader',
        onInit: function($el) {
            const loader = new ciBodyLoader();
            const newLazyLoadHtmlIndex = data.get('lazyLoadHtmlIndex') + 1;
    
            loader.init({
                id: 'ci-lazy-html-loader-' + newLazyLoadHtmlIndex,
                resizeToParent: true,
                bodyLock: false,
                imageSrc: `${ICUBE_CONFIG.static_domain}assets/publicarea/images/tail-spin.svg`
            });
            data.set('lazyLoadHtmlIndex', newLazyLoadHtmlIndex);
            $el.prepend(loader.$loader);
            $el.data('loader', loader);
        },
        beforeRequest: function($el) {
            $el.data('loader').show();
        },
        afterRender: function($el) {                
            $el.data('loader').hide();
        }
    }
}